<template>
  <div v-if="orderList.goods == undefined && $route.query.type == 1"></div>
  <div class="pays" v-else>
    <!-- 顶部导航 -->
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="1rem" @click="back" />
      <span>确认订单</span>
      <div></div>
    </div>
    <!-- 修改地址 -->
    <div class="adress" @click='gosite' v-if="defaultAddress.length != 0">
      <div class="top">
        <div>
          <van-icon name="location-o" style="font-size: 0.8rem; position: relative; top: 2px;" />
          <span>{{defaultAddress.province}}{{defaultAddress.city}}{{defaultAddress.area}}{{defaultAddress.address}}</span>
        </div>
        <div>
          <van-icon name="arrow" style="margin-top: 33px;" />
        </div>
      </div>
      <div class="bottom">
        <span>{{defaultAddress.phone}}</span>
        <span>{{defaultAddress.real_name}}</span>
      </div>
    </div>
    <div class="adress_none" @click='gosite' v-else>
      <van-cell title="您还没有地址,快去添加一个吧~" is-link to="/site" />
    </div>
    <!-- 订单信息 -->
    <div class="order">
      <div class="list" v-if="$route.query.type == 1">
        <van-card :desc="orderList.goods_spec_combination.goods_spec_name">

          <div slot="thumb" class="list_thumb">
            <img :src="orderList.goods_spec_combination.goods_image | handleUrl" alt="">
          </div>

          <div slot="title" class="order_title">
            <div>{{orderList.goods.title}}</div>
          </div>
          <div slot="tags" class="order_btn color_b2">
            <span>{{orderList.lease_title}}</span>
          </div>
        </van-card>
      </div>
      <!-- 购物车结算页面显示 -->
      <div class="list" v-for="item in cartsList" v-else>
        <van-card :desc="item.goods_spec_combination.goods_spec_name">
          <div slot="thumb">
            <img :src="item.goods_spec_combination.goods_image | handleUrl" alt="">
          </div>
          <div slot="title" class="order_title">
            <div>{{item.goods.title}}</div>
          </div>
          <div slot="tags" class="color_b2">
            <span>{{item.lease_title}}</span>
          </div>
          <div slot="tags" class="">
            <div class="order_title_price">
              <span v-if='cartsList[0].lease_id == 6'>买断金额¥{{item.goods_spec.data.total}} x{{item.cart_num}}</span>
              <span v-if='cartsList[0].lease_id == 7'>首年月租金
                <span v-if="$route.query.type == 1">￥{{deposit.toFixed(1)}}</span>
                <span v-else>￥{{item.goods_spec.data.Lease_algorithm_price}} x{{item.cart_num}}</span>
              </span>
              <span v-if='cartsList[0].lease_id == 4'>月租金
                <span v-if="$route.query.type == 1">￥{{deposit.toFixed(1)}}</span>
                <span v-else>￥{{item.goods_spec.data.Lease_algorithm_price}} x{{item.cart_num}}</span>
              </span>
            </div>
          </div>
        </van-card>
      </div>
    </div>
    <!-- 在线客服 -->
    <div class="zaixiankfs" v-if="$route.query.type == 1 && category_id == 1">
      <p>您还可以&nbsp;&nbsp;</p>
      <router-link to="/yuyueshangmen"><span>预约上门</span></router-link>
      <p>或&nbsp;</p>
      <span @click="open53()">在线客服</span>
      <p>沟通</p>
    </div>
    <div class="doubt" v-if="$route.query.type == 1 && category_id == 1">
      <van-cell-group style="display: flex; justify-content: space-between; width: 100%;">
        <div class="efwes">
          <div>选择数量</div>
        </div>
        <div>
          <van-stepper button-size="1.1rem" input-width="1.5rem" v-model="num" />
        </div>
      </van-cell-group>
    </div>
    <div class="doubt" v-if="category_id == 1 || $route.query.type == 2">
      <van-cell-group>
        <div class="efwes">
          <div>运输安装费</div>
          <div>¥{{logisticsPrice}}</div>
        </div>
        <div class="asdwsd">
          租金金额满5000元免运输安装费
        </div>
      </van-cell-group>
    </div>
    <!-- 用户留言 -->
    <div class="message">
      <van-cell-group>
        <van-field v-model="message" maxlength="200" autosize label="买家留言" type="textarea" placeholder="请输入留言"
          show-word-limit />
      </van-cell-group>
    </div>
    <!-- 以下为支付页面显示-->
    <div v-if="$route.query.type == 1">
      <van-cell class="service" style="margin-bottom: 0.6rem;">
        <div slot="title" class="service_title">
          <div v-if="category_id == 1 && orderList.lease_id == 7">
            <span v-if="orderList.lease_id == 6">需支付<span style="color: red;">买断金额总计</span></span>
            <span v-if="orderList.lease_id == 7 || orderList.lease_id == 4">需支付<span
                style="color: red;">首年租金</span></span>
            <span style="color: red; font-weight: bold;">¥{{(deposit*12).toFixed(1)}}</span>
          </div>
          <div v-else-if="category_id == 1 && orderList.lease_id == 4">
            <span v-if="orderList.lease_id == 6">需支付<span style="color: red;">买断金额总计</span></span>
            <span v-if="orderList.lease_id == 7 || orderList.lease_id == 4">需支付<span
                style="color: red;">首月租金</span></span>
            <span style="color: red; font-weight: bold;">¥{{deposit.toFixed(1)}}</span>
          </div>
          <!-- 二手商品显示-->
          <div v-else>
            <span>商品金额</span>
            <span><span class="color_f14">¥{{money.toFixed(1)}}</span></span>
          </div>
          <!-- -->
          <div v-if="category_id == 1">
            <div style="margin-left: 0.8rem;" v-if="orderList.lease_id == 7">
              <span style="display: flex; justify-content: flex-end;">
                <div>
                  <span class="color_b3">租金¥{{deposit.toFixed(1)}}X12个月</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </van-cell>
      <!-- 一次性买断-->
      <van-cell v-if="orderList.lease_id == 6 && category_id == 1 " class="service"
        style="margin-bottom: 0.6rem; font-size: 0.75rem;  ">
        <div style="text-align: right;" class="color_b2">
          市场购买参考含税价¥{{sczdj.toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sczdj-money).toFixed(1)}}</span>
        </div>
      </van-cell>
      <!-- 24个月+续租-->
      <van-cell v-if="orderList.lease_id == 7 && category_id == 1 " class="service"
        style="margin-bottom: 0.6rem; font-size: 0.75rem;  ">
        <span style="display: flex; justify-content: flex-end;  ">
          <div style="width: 10px;"></div>
          <div>
            <span class="color_b2">市场购买参考含税价¥{{sczdj.toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sczdj-money).toFixed(1)}}</span></span>
          </div>
        </span>
      </van-cell>
      <!-- 押三付三-->
      <van-cell v-if="orderList.lease_id == 4 && category_id == 1 " class="service"
        style="margin-bottom: 0.6rem; font-size: 0.75rem;  ">
        <span style="display: flex; justify-content: flex-end;">
          <div style="width: 10px;"></div>
          <div>
            <span class="color_b2">市场购买参考含税价¥{{sczdj.toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sczdj-money).toFixed(1)}}</span></span>
          </div>
        </span>
      </van-cell>
    </div>
    <!-- 以下为购物车结算页面显示-->
    <div v-else>
      <van-cell class="service" style="margin-bottom: 0.6rem;">
        <div slot="title" class="service_title">
          <span v-if="cartsList[0].lease_id == 6 ">需支付<span style="color: red;">买断金额总计</span></span>
          <span v-if="cartsList[0].lease_id == 7">需支付<span style="color: red;">首年租金</span></span>
          <span v-if="cartsList[0].lease_id == 4">需支付<span style="color: red;">首月租金</span></span>
          <span v-if="cartsList[0].lease_id == 4"
            style="color: red; font-weight: bold;">¥{{cartDeposit.toFixed(1)}}</span>
          <span v-else style="color: red; font-weight: bold;">¥{{money.toFixed(1)}}</span>

          <div v-if="cartsList[0].lease_id == 7" style="margin-left: 0.8rem;">
            <span style="display: flex; justify-content: flex-end;">
              <div>
                <span class="color_b3">租金¥{{cartDeposit.toFixed(1)}}X12个月</span>
              </div>
            </span>
          </div>
          <div v-if="cartsList[0].lease_id == 4" style="margin-left: 0.8rem;">
            <span style="display: flex; justify-content: flex-end;">
            </span>
          </div>
        </div>
      </van-cell>
      <van-cell v-if="cartsList[0].lease_id == 6 " class="service" style="margin-bottom: 0.6rem; font-size: 0.75rem;  ">
        <div style="text-align: right;" class="color_b2">市场购买参考含税价¥{{sczdjg.toFixed(1)}},为您节省￥<span style="color: #7dcd7c;">{{(sczdj-money).toFixed(1)}}</span></div>
      </van-cell>
      <van-cell v-if="cartsList[0].lease_id == 7 " class="service" style="margin-bottom: 0.6rem; font-size: 0.75rem;  ">
        <span style="display: flex; justify-content: flex-end;  ">
          <div style="width: 10px;"></div>
          <div>
            <span class="color_b2">市场购买参考含税价¥{{sczdjg}},为您节省￥<span style="color: #7dcd7c;">{{(sczdj-money).toFixed(1)}}</span></span>
          </div>
        </span>

      </van-cell>
      <van-cell v-if="cartsList[0].lease_id == 4 " class="service" style="margin-bottom: 0.6rem; font-size: 0.75rem;  ">
        <span style="display: flex; justify-content: flex-end;  ">
          <div style="width: 10px;"></div>
          <div>
            <span class="color_b2">市场购买参考含税价¥{{sczdjg}},为您节省￥<span style="color: #7dcd7c;">{{(sczdj-money).toFixed(1)}}</span></span>
          </div>
        </span>
      </van-cell>
    </div>


    <!-- 底部按钮 -->
    <div class="btn btn_order" style="display: flex;">
      <div>
        <span class="color_f14" style="font-size: 0.8rem; margin-right: 0.2rem; line-height: 27px;">合计</span>
        <span v-if="orderList.lease_id == 7" class="color_f14">¥{{this.jiar((deposit*12).toFixed(1),logisticsPrice)}}</span>
        <span v-else-if="orderList.lease_id == 4"
          class="color_f14">¥{{this.jiar(deposit.toFixed(1),logisticsPrice)}}</span>
        <span v-else class="color_f14">¥{{this.jiar(money.toFixed(1),logisticsPrice)}}</span>
      </div>
      <div v-if="category_id == 1 && this.$route.query.type == 1">
        <van-goods-action-button type="warning" text="加入购物车" class="btn-yuyue btn-yuyue1" @click="ongouwuche()" />
        <van-goods-action-button
          style="font-size: 14px; font-weight: bold; border-top-left-radius: 0px; border-bottom-left-radius: 0px;"
          class="btn-tijiao" color="#f1452f" round size="small" @click="submit" text="立即支付" />
      </div>
      <div v-else>
        <van-goods-action-button style="font-size: 14px; font-weight: bold; " class="btn-tijiao" color="#f1452f" round
          size="small" @click="submit" text="立即支付" />
      </div>
    </div>
    <!-- 选择支付方式 -->
    <van-popup v-model="show" position="bottom">
      <van-panel class="payment">
        <div slot="header" class="payment_header">
          支付方式
        </div>
        <div class="payment_content">
          <van-radio-group v-model="radio">
            <van-cell-group>
              <van-cell title="微信支付" clickable @click="radio='1'">
                <div slot="icon" class="payment_icon">
                  <img src="../../assets/wx.png" alt="">
                </div>
                <van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
              </van-cell>
              <van-cell title="支付宝支付" clickable @click="radio='2'">
                <div slot="icon" class="payment_icon">
                  <img src="../../assets/zfb.png" alt="">
                </div>
                <van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
              </van-cell>
              <!-- <van-cell title="银行卡支付" clickable @click="radio='3'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/yl.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" disabled slot="right-icon" name="3" />
							</van-cell> -->
            </van-cell-group>
          </van-radio-group>
          <div class="pays_btn">
            <button class="left-button" @click="duig=true">对公转账</button>
            <button class="right-button" @click="submitPay">立即付款</button>
          </div>
        </div>
      </van-panel>
    </van-popup>
    <!-- 对公转账 -->
    <van-popup v-model="duig" class="duig" position="bottom">
      <div class="duig-top">对公账户</div>
      <van-cell size="large">
        <div slot="title" class="duig-title">
          <div>开户名称：</div>
          <div>广州俱百家享租科技集团有限公司</div>
        </div>
      </van-cell>
      <van-cell size="large">
        <div slot="title" class="duig-title">
          <div>开户账户：</div>
          <div>3602073809100114062</div>
        </div>
      </van-cell>
      <van-cell size="large">
        <div slot="title" class="duig-title">
          <div>开户银行：</div>
          <div>中国工商银行广州泰沙路支行</div>
        </div>
      </van-cell>
      <div class="duig-foot">
        如果您付款成功，请在<span>会员中心</span>-<span>我的订单</span>-<span>待支付订单</span>中上传您的支付凭证，我们会第一时间核实并发货。若有问题请联系客服
        400-8722-000</div>
      <div class="duig-btn">
        <van-button round size="small" @click="sateway" style=" border: 1px solid #eee;">取消</van-button>
        <van-button round color="#f1452f" size="small" @click="gateway" style=" border: 1px solid #f1452f;">提交订单
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Address from '@/components/location'
  import Loding from '@/components/loding'
  import Login from '@/components/login/login'
  import Detail from '@/components/detail/detail'

  export default {
    data() {
      return {
        duig: false,
        message: '',
        show: false,
        radio: '1',
        orderList: [], //单件商品
        cartsList: [], //购物车商品
        totalMoney: 0, //总价
        money: 0, //商品价格
        deposit: 0, //单件押金
        cartDeposit: 0, //购物车押金
        num: 1, //单件数量
        //已保存的地址
        defaultAddress: [],
        chosenAddressId: 1, //默认选择
        list: [],
        logisticsPrice: 0,
        total: 0, //购物车订单数量,
        logisticsPrice_z: 0,
        logisticsPrice_g: 0,
        logisticsPrice_t: 0,
        category_id: 0,
        wan: 0,
        sczdj: 0,
        xz: 0,
        zje: 0,
        sczdjg: 0,
        xzg: 0,
        zjeg: 0,
        yueshu: 0
      }
    },
    components: {
      Address
    },
    created() {
      if (this.$route.query.type == 1) {
        this.num = this.$route.query.value;
        // this.num .toFixed(2);
        //获取商品信息
        this.$axios.post(baseUrl + '/mobile/Order/orderOne', {
          token: localStorage.getItem('Authorization'),
          goods_id: this.$route.query.id,
          lease_id: this.$route.query.typeId,
          combination_id: this.$route.query.sizeId,
          category_id: this.$route.query.category_id
        }).then((res) => {
          if (res.data.code == 2) {
            this.category_id = res.data.data.goods.category_id;
            this.orderList = res.data.data;
            let temporary = this.num * this.orderList.goods_spec.data.total;
            this.money = this.num * this.orderList.goods_spec.data.total;
            this.deposit = this.num * this.orderList.goods_spec.data.Lease_algorithm_price;
            this.wan = this.orderList.goods_spec.data.Lease_deposit_price
            this.sczdj = this.num * this.orderList.goods_spec.data.market_price;
            this.xz = this.num * this.orderList.goods_spec.data.Lease_month_price;
            this.zje = this.num * this.orderList.goods_spec.data.lease_all;
            this.yueshu = parseFloat(this.orderList.lease_title) / 2
            var total;
            if (this.money == this.deposit) {
              total = this.money
            } else {
              total = this.money - this.deposit
            }
            this.$axios.post(baseUrl + '/mobile/Order/logisticsPrice', {
              total: total,
              category_id: this.$route.query.category_id,
              lease_id: this.orderList.lease_id,
              Lease_deposit_price: this.orderList.goods_spec.data.Lease_algorithm_price
            }).then((res) => {
              if (res.data.code == 2) {
                this.logisticsPrice = res.data.data;
                this.cartDeposit = this.orderList.goods_spec.data.Lease_algorithm_price *
                  this.num;
                this.totalMoney = temporary + this.logisticsPrice;
              } else {
                this.$toast(res.data.msg);
              }
            }).catch((err) => {
              console.log(err);
            })
          }
        }).catch((err) => {
          console.log(err);
        })
      } else {
        this.$axios.post(baseUrl + '/mobile/Order/addOrderCache', {
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          if (res.data.code == 2) {
            this.cartsList = res.data.data;
            console.log(this.cartsList[0].lease_id)
            let moeny_z = 0;
            this.yueshu = parseFloat(this.cartsList[0].lease_title)
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].category_id == 1) {
                moeny_z += res.data.data[i].goods_spec.data.total * res.data.data[i].cart_num;
              }
              this.xzg += (res.data.data[i].goods_spec.data.Lease_month_price * res.data
                .data[i].cart_num);
              this.zjeg += (res.data.data[i].goods_spec.data.lease_all * res.data
                .data[i].cart_num);
              this.money += (res.data.data[i].goods_spec.data.total * res.data.data[i].cart_num);
              this.sczdjg += (res.data.data[i].goods_spec.data.market_price * res.data
                .data[i].cart_num);
              console.log(this.sczdjg)
              this.cartDeposit += (res.data.data[i].goods_spec.data.Lease_algorithm_price * res.data
                .data[i].cart_num);

            }
            var total_arr;
            if (moeny_z == this.cartDeposit) {
              total_arr = moeny_z
            } else {
              total_arr = moeny_z - this.cartDeposit
            }
            this.$axios.post(baseUrl + '/mobile/Order/logisticsPrice', {
              total: total_arr,
              category_id: 1,
              Lease_deposit_price: res.data.data[0].goods_spec.data.Lease_algorithm_price,
              lease_id: res.data.data[0].lease_id
            }).then((res) => {
              if (res.data.code == 2) {
                this.logisticsPrice = res.data.data;
                this.totalMoney = this.logisticsPrice + this.money;
              } else {
                this.$toast(res.data.msg);
              }
            }).catch((err) => {
              console.log(err);
            })
          } else {
            this.$toast(res.data.msg);
          }
        }).catch((err) => {
          console.log(err);
        })
      }
      //获取地址
      this.$axios.post(baseUrl + '/mobile/User/userAddressStatus', {
        token: localStorage.getItem('Authorization')
      }).then((res) => {
        if (res.data.code == 2) {
          this.defaultAddress = res.data.data
        }
      }).catch((err) => {
        console.log(err);
      })
    },

    methods: {
      //确认提交
      submit() {
        if (this.defaultAddress.length != 0) {
          this.show = true;
        } else {
          this.$toast('您还没有设置地址哦~');
        }
      },
      // 加入购物车或提交订单
      ongouwuche() {
        if (this.category_id == 1) {
          this.$axios.post(baseUrl + '/mobile/Cart/cartAdd', {
            goods_id: this.$route.query.id,
            lease_id: this.$route.query.typeId,
            combination_id: this.$route.query.sizeId,
            cart_num: this.num,
            category_id: this.$route.query.category_id,
            token: localStorage.getItem('Authorization')
          }).then((res) => {
            if (res.data.code == 5) {
              console.log(res)
              this.$toast("加入购物车成功！");
              this.select = false;
            } else {
              this.$toast("您选择的租赁方式与购物车中不一致，请重新选择租赁时间或清空购物车！");
            }
          }).catch((err) => {
            console.log(err);
          })
        } else {
          this.$axios.post(baseUrl + '/mobile/Cart/cartAdd', {
            goods_id: this.$route.query.id,
            lease_id: 0,
            combination_id: this.$route.query.sizeId,
            cart_num: this.num,
            category_id: this.$route.query.category_id,
            token: localStorage.getItem('Authorization')
          }).then((res) => {
            if (res.data.code == 5) {
              this.$toast("加入购物车成功！");
              this.select = false;
            } else {
              this.$toast("您选择的租赁方式与购物车中不一致，请重新选择租赁时间或清空购物车！");
            }
          }).catch((err) => {
            console.log(err);
          })
        }
      },
      // 对公转账订单提交
      gateway() {
        if (this.$route.query.type == 1) {
          this.$axios.post(baseUrl + '/mobile/Order/addOneOrder', {
            address_id: this.defaultAddress.id,
            is_channel: this.radio,
            order_message: this.message,
            goods_id: this.orderList.goods.id,
            combination_id: this.orderList.goods_spec_combination.id,
            num: this.num,
            lease_id: this.$route.query.typeId,
            category_id: this.orderList.goods.category_id,
            token: localStorage.getItem('Authorization'),
            gateway: 1
          }).then((res) => {
            if (res.data.code == 19) {
              this.$toast("提交成功");
              this.$router.push({
                path: '/order',
                query: {
                  index: 0
                }
              })
            }
          })
        } else {
          var cart_id = [];
          for (var i in this.cartsList) {
            cart_id.push(this.cartsList[i].id);
          }
          if (this.radio == '1') {
            this.$axios.post(baseUrl + '/mobile/Order/addOrder', {
              id: cart_id,
              address_id: this.defaultAddress.id,
              is_channel: this.radio,
              order_message: this.message,
              token: localStorage.getItem('Authorization'),
              gateway: 1
            }).then((res) => {
              if (res.data.code == 19) {
                this.$toast("提交成功");
                this.$router.push({
                  path: '/order',
                  query: {
                    index: 0
                  }
                })
              }
            }).catch((err) => {
              console.log(err);
            })
          } else if (this.radio == '2') {
            this.$axios.post(baseUrl + '/mobile/Order/addOrder', {
              id: cart_id,
              goods_id: goods_list,
              num: num_list,
              category_id: category_id,
              combination_id: combination_list,
              lease_id: lease_list,
              address_id: this.defaultAddress.id,
              is_channel: this.radio,
              order_message: this.message,
              token: localStorage.getItem('Authorization'),
              gateway: 1
            }).then((res) => {
              if (res.data.code == 19) {
                this.$toast("提交成功");
                this.$router.push({
                  path: '/order',
                  query: {
                    index: 0
                  }
                })
              }
            }).catch((err) => {
              console.log(err);
            })
          }
        }
      },
      // 取消对公转账订单
      sateway() {
        this.duig = false;
        this.show = false;
        this.$axios.post(baseUrl + '/mobile/Order/addOneOrder', {
          address_id: this.defaultAddress.id,
          is_channel: this.radio,
          order_message: this.message,
          goods_id: this.orderList.goods.id,
          combination_id: this.orderList.goods_spec_combination.id,
          num: this.num,
          lease_id: this.$route.query.typeId,
          category_id: this.orderList.goods.category_id,
          token: localStorage.getItem('Authorization'),
          gateway: 1,
          gateway_state: 1
        }).then((res) => {
          if (res.data.code == 19) {

          }
        })
      },

      // 这里
      //确认支付
      submitPay() {
        var message = this.message,
          wx = (() => {
            return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
          })();
        if (this.message == '') {
          message = '暂无留言'
        }
        if (this.$route.query.type == 1) {
          if (wx) {
            alert("请在微信以外的浏览器打开进行支付");
            return false;
          } else {
            if (this.radio == '1') {
              this.$axios.post(baseUrl + '/mobile/Order/addOneOrder', {
                address_id: this.defaultAddress.id,
                is_channel: this.radio,
                order_message: message,
                goods_id: this.orderList.goods.id,
                combination_id: this.orderList.goods_spec_combination.id,
                num: this.num,
                lease_id: this.$route.query.typeId,
                category_id: this.orderList.goods.category_id,
                token: localStorage.getItem('Authorization'),
                market_price: this.sczdj,
                // lease_all:this.zje,
                Lease_month_one_price: this.deposit,
                Lease_month_price: this.xz,
              }).then((res) => {
                if (res.data.code == 19) {
                  window.location.href = baseUrl + '/mobile/Pay/wapWxPay?out_trade_no=' + res
                    .data.data
                  this.$router.push({
                    path: '/orderDetail',
                    query: {
                      order_number: res.data.data
                    }
                  })
                }
              }).catch((err) => {
                console.log(err);
              })
            } else if (this.radio == '2') {
              this.$axios.post(baseUrl + '/mobile/Order/addOneOrder', {
                address_id: this.defaultAddress.id,
                is_channel: this.radio,
                order_message: message,
                goods_id: this.orderList.goods.id,
                combination_id: this.orderList.goods_spec_combination.id,
                num: this.num,
                lease_id: this.$route.query.typeId,
                category_id: this.orderList.goods.category_id,
                token: localStorage.getItem('Authorization'),
                market_price: this.sczdj,
                // lease_all:this.zje,
                Lease_month_one_price: this.deposit,
                Lease_month_price: this.xz,
              }).then((res) => {
                if (res.data.code == 19) {
                  window.location.href = baseUrl + '/mobile/Pay/wapPay?out_trade_no=' + res.data
                    .data
                  this.$router.push({
                    path: '/orderDetail',
                    query: {
                      order_number: res.data.data
                    }
                  })
                }
              }).catch((err) => {
                console.log(err);
              })
            } else {
              this.$toast('暂不支持');
            }
          }
        } else {
          if (wx) {
            alert("请在微信以外的浏览器打开进行支付");
            return false;
          } else {
            var cart_id = [];
            for (var i in this.cartsList) {
              cart_id.push(this.cartsList[i].id);
            }
            if (this.radio == '1') {
              this.$axios.post(baseUrl + '/mobile/Order/addOrder', {
                id: cart_id,
                address_id: this.defaultAddress.id,
                is_channel: this.radio,
                order_message: message,
                token: localStorage.getItem('Authorization'),
                market_price: this.sczdjg,
                // lease_all:this.zjeg,
                Lease_month_one_price: this.cartDeposit,
                Lease_month_price: this.xzg,
              }).then((res) => {
                if (res.data.code == 19) {
                  window.location.href = baseUrl + '/mobile/Pay/wapWxPay?out_trade_no=' + res
                    .data.data
                }
              }).catch((err) => {
                console.log(err);
              })
            } else if (this.radio == '2') {
              this.$axios.post(baseUrl + '/mobile/Order/addOrder', {
                id: cart_id,
                address_id: this.defaultAddress.id,
                is_channel: this.radio,
                order_message: message,
                token: localStorage.getItem('Authorization'),
                market_price: this.sczdjg,
                // lease_all:this.zjeg,
                Lease_month_one_price: this.cartDeposit,
                Lease_month_price: this.xzg,
              }).then((res) => {
                if (res.data.code == 19) {
                  window.location.href = baseUrl + '/mobile/Pay/wapPay?out_trade_no=' + res.data
                    .data
                }
              }).catch((err) => {
                console.log(err);
              })
            } else {
              this.$toast('暂不支持');
            }
          }
        }
      },
      //转地址
      gosite() {
        this.$router.push({
          path: '/site'
        })
      },
      jiar(a, b) {
        console.log(a, b, '123123123')
        a = +a
        b = +b
        return a + b
      },
    },
    watch: {
      'num': function(newValue) {
        let temporary = newValue * this.orderList.goods_spec.data.total;
        this.sczdj = newValue * this.orderList.goods_spec.data.total * 1.8;
        this.xz = newValue * this.orderList.goods_spec.data.Lease_month_price;
        this.zje = newValue * this.orderList.goods_spec.data.lease_all;
        this.money = newValue * this.orderList.goods_spec.data.total;
        this.deposit = newValue * this.orderList.goods_spec.data.Lease_algorithm_price;
        var total = this.money - this.deposit;
        this.$axios.post(baseUrl + '/mobile/Order/logisticsPrice', {
          total: total,
          category_id: this.$route.query.category_id,
          lease_id: this.orderList.lease_id,
          Lease_deposit_price: this.orderList.goods_spec.data.Lease_algorithm_price*newValue
        }).then((res) => {
          if (res.data.code == 2) {
            this.logisticsPrice = res.data.data;
            this.cartDeposit = this.orderList.goods_spec.data.Lease_deposit_price * newValue;
            this.totalMoney = temporary + this.logisticsPrice;
          } else {
            this.$toast(res.data.msg);
          }
        }).catch((err) => {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  @import 'pays.css';


  img {
    height: 5.5rem;
    object-fit: cover;
  }

  .btn_order>>>.van-goods-action-button--warning {

    width: 2rem;
  }

  .btn-yuyue {
    width: 2rem;
  }

  .btn>>>.van-goods-action-button {
    font-size: 0.75rem;
  }

  .btn-yuyue1 {
    border-bottom-left-radius: 20px;
    border-top-left-radius: 20px;
    font-weight: bold;
    font-size: 14px !important;
  }

  .van-hairline--top-bottom:after,
  .van-hairline-unset--top-bottom:after {
    border-width: 0px 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/carts/pays.vue